export const blockIconsHardwareScaleNew = (
	<span className='material-symbols-outlined'>scale</span>
);
